import { createContext, useReducer } from 'react';
import bookingReducer, {
  BookingReducerAction,
  bookingReducerInitialState,
  BookingReducerState,
} from './reducers/bookingReducer';
import customerReducer, {
  CustomerReducerAction,
  customerReducerInitialState,
  CustomerReducerState,
} from '../../../redusers/customer-reducer';
import selecetedShopIdReducer, {
  SelecetedShopIdReducerAction,
  selecetedShopIdReducerInitialState,
  SelecetedShopIdReducerState,
} from '../../../redusers/selected-shop-id-reducer';
import selecetedDateReducer, {
  SelecetedDateReducerState,
  SelectedDateReducerAction,
  selectedDateReducerInitialState,
} from '../../../redusers/selectedDateReducer';
import paymentReducer, {
  PaymentReducerAction,
  paymentReducerinitialState,
  PaymentReducerState,
} from '../../../redusers/payment-reducer';
import selecetedItemCategoryReducer, {
  SelecetedItemCategoryAction,
  SelecetedItemCategoryState,
  selectedItemCategoryReducerInitialState,
} from '../../../redusers/selected-item-category-reducer';
import isSummaryOpenReducer, {
  IsSummaryOpenAction,
  isSummaryOpenReducerInitialState,
  IsSummaryOpenState,
} from '../../../redusers/is-summary-open-reducer';
import currentStepReducer, {
  CurrentStepReducerAction,
  currentStepReducerInitialState,
  CurrentStepReducerState,
} from '../../../redusers/current-step-reducer';
import orderReducer, {
  OrderReducerAction,
  orderReducerInitialState,
  OrderReducerState,
} from '../../../redusers/order-reducer';
import termsReducer, {
  TermsReducerAction,
  termsReducerInitialState,
  TermsReducerState,
} from '../../../redusers/terms-reducer';
import errorReducer, {
  ErrorReducerAction,
  errorReducerinitialState,
  ErrorReducerState,
} from '../../../redusers/error-reducer';
import vouchersReducer, {
  VouchersReducerAction,
  vouchersReducerInitialState,
  VouchersReducerState,
} from '../../../redusers/vouchers-reducer';
import voucherReducer, {
  VoucherReducerAction,
  voucherReducerInitialState,
  VoucherReducerState,
} from '../../../redusers/voucher-reducer';
import isWarrantyAppliedReducer, {
  IsWarrantyAppliedAction,
  isWarrantyAppliedReducerInitialState,
  IsWarrantyAppliedState,
} from '../../../redusers/is-warranty-applied-reducer';
import loadingReducer, {
  LoadingReducerAction,
  loadingReducerInitialState,
  LoadingReducerState,
} from '../../../redusers/loading-reducer';
import createCombinedStateReducer from '../../../Utils/create-combined-state-reducer';
import previousStepReducer, {
  PreviousStepReducerAction,
  previousStepReducerInitialState,
  PreviousStepReducerState,
} from 'redusers/previous-step-reducer';
import hasDefaultDurationBeenSetReducer, {
  HasDefaultDurationBeenSetReducerAction,
  hasDefaultDurationBeenSetReducerInitialState,
  HasDefaultDurationBeenSetReducerState,
} from 'redusers/has-default-duration-been-set-reducer';

export type BookingStateAction =
  | BookingReducerAction
  | SelecetedShopIdReducerAction
  | CurrentStepReducerAction
  | PreviousStepReducerAction
  | SelectedDateReducerAction
  | CustomerReducerAction
  | IsWarrantyAppliedAction
  | SelecetedItemCategoryAction
  | OrderReducerAction
  | PaymentReducerAction
  | VoucherReducerAction
  | VouchersReducerAction
  | TermsReducerAction
  | IsSummaryOpenAction
  | LoadingReducerAction
  | ErrorReducerAction
  | HasDefaultDurationBeenSetReducerAction;

export interface BookingStateCombinedState {
  state: {
    booking: BookingReducerState;
    selectedShopId: SelecetedShopIdReducerState;
    currentStep: CurrentStepReducerState;
    previousStep: PreviousStepReducerState;
    selectedDate: SelecetedDateReducerState;
    customer: CustomerReducerState;
    isWarrantyApplied: IsWarrantyAppliedState;
    selectedItemCategory: SelecetedItemCategoryState;
    order: OrderReducerState;
    payment: PaymentReducerState;
    voucher: VoucherReducerState;
    vouchers: VouchersReducerState;
    terms: TermsReducerState;
    isSummaryOpen: IsSummaryOpenState;
    loading: LoadingReducerState;
    errors: ErrorReducerState;
    hasDefaultDurationBeenSet: HasDefaultDurationBeenSetReducerState;
  };
  dispatch: React.Dispatch<BookingStateAction>;
}

const bookingStateInitialState: BookingStateCombinedState = {
  state: {
    booking: bookingReducerInitialState,
    customer: customerReducerInitialState,
    selectedShopId: selecetedShopIdReducerInitialState,
    selectedDate: selectedDateReducerInitialState,
    payment: paymentReducerinitialState,
    selectedItemCategory: selectedItemCategoryReducerInitialState,
    isSummaryOpen: isSummaryOpenReducerInitialState,
    currentStep: currentStepReducerInitialState,
    previousStep: previousStepReducerInitialState,
    order: orderReducerInitialState,
    terms: termsReducerInitialState,
    errors: errorReducerinitialState,
    vouchers: vouchersReducerInitialState,
    voucher: voucherReducerInitialState,
    isWarrantyApplied: isWarrantyAppliedReducerInitialState,
    loading: loadingReducerInitialState,
    hasDefaultDurationBeenSet: hasDefaultDurationBeenSetReducerInitialState,
  },
  dispatch: () => {},
};

export const bookingState = createContext(bookingStateInitialState);

const bookingStateReducers = {
  booking: bookingReducer,
  customer: customerReducer,
  selectedShopId: selecetedShopIdReducer,
  selectedDate: selecetedDateReducer,
  payment: paymentReducer,
  selectedItemCategory: selecetedItemCategoryReducer,
  isSummaryOpen: isSummaryOpenReducer,
  currentStep: currentStepReducer,
  previousStep: previousStepReducer,
  order: orderReducer,
  terms: termsReducer,
  errors: errorReducer,
  vouchers: vouchersReducer,
  voucher: voucherReducer,
  isWarrantyApplied: isWarrantyAppliedReducer,
  loading: loadingReducer,
  hasDefaultDurationBeenSet: hasDefaultDurationBeenSetReducer,
};

interface BookingStateProviderProps {
  children: React.ReactNode;
}

const BookingStateProvider = (props: BookingStateProviderProps) => {
  const bookingStateReducer = createCombinedStateReducer(bookingStateReducers);

  // Initial will be without server data as it is not available yet
  const [state, dispatch] = useReducer(
    bookingStateReducer,
    bookingStateInitialState.state
  );

  return (
    <bookingState.Provider value={{ state, dispatch }}>
      {props.children}
    </bookingState.Provider>
  );
};

export default BookingStateProvider;
